import * as types from './actionTypes.js';
import { SHOW_RECOLORING_LOADER } from './actionTypes';

export const selectSwatchItem = (id, color) => ({
    type: types.UI_SWATCH_SELECTED,
    id,
    color,
});

export const showPicker = () => ({
    type: types.UI_PICKER_SHOWN,
});

export const hidePicker = () => ({
    type: types.UI_PICKER_HIDED,
});

export const toggleInputFocus = bool => ({
    type: types.UI_COLOR_INPUT_FOCUS_TOGGLED,
    bool,
});

export const showAllSwatches = bool => ({
    type: types.SHOW_ALL_SWATCHES_SELECTED,
    bool,
});

export const siteSearchFocused = () => ({
    type: types.SITESEARCH_FOCUSED,
});

export const siteSearchBlurred = () => ({
    type: types.SITESEARCH_BLURRED,
});

export const siteSearchChanged = searchValue => ({
    type: types.SITESEARCH_CHANGED,
    searchValue,
});

export const resetColorSlider = bool => ({
    type: types.COLOR_SLIDER_RESETTED,
    bool,
});

export const showSnack = (id, messageId, label = null, autohide = 3000, action = null) => ({
    type: types.SHOW_SNACKBAR,
    id,
    messageId,
    label,
    autohide,
    action,
});

export const dismissSnack = id => ({
    type: types.DISMISS_SNACKBAR,
    id,
});

export const showRecoloringLoader = () => ({
    type: types.SHOW_RECOLORING_LOADER,
});

export const hideRecoloringLoader = () => ({
    type: types.HIDE_RECOLORING_LOADER,
});

export const intersectionTriggered = (count, pagePerLoad) => ({
    type: types.LAZY_LOAD_INTERSECTION_TRIGGERED,
    count,
    pagePerLoad,
});

export const toggleHeaderMenu = () => ({
    type: types.UI_TOGGLE_HEADER_MENU,
});

export const toggleFigurinePreview = () => ({
    type: types.UI_TOGGLE_FIGURINE_PREVIEW,
});



// WEBPACK FOOTER //
// ./src/actions/uiActions.js